import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, 
    private tokenService: TokenService,
    private router: Router,
    private activateroute: ActivatedRoute) {
     
  }

  canActivate( next: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkUserLogin(next, url);
  }
  checkUserLogin(routes: ActivatedRouteSnapshot, url: any): boolean {
    const requiredRole = routes?.data['role'];
    // console.log(requiredRole,'requiredRole')
    // const bypassRoutes = ['/customer-cif'];
    // if (bypassRoutes.some(route => url.includes(route))) {
    //   return true; // Allow access without login check
    // }
    if(this.tokenService.getToken() && this.tokenService.getRefreshToken()){
      const userRole = this.authService.getUserRoleType();
      // console.log(userRole,'userRole')
      if (requiredRole.length!=0) {
        // const allowedRoles = requiredRole.split(','); // Allows multiple roles in the data property
        // Check if user role is allowed
        if (requiredRole.includes(userRole)) {
          return true; // User has the required role
        }
      }
      this.router.navigate(['/login']);
      return false;
      // if (routes?.data?.['role'] && routes?.data?.['role'].indexOf(userRole) === -1) {
      //   this.router.navigate(['/login']);
      //   return false;
      // }
      // return true;
    }else{
      this.router.navigate(['/login']);
      return false;
    }
  }


  // canActivate(): boolean {
  //   return true;
  //   if (this.authService.isAuthenticated()) {
  //     console.log('auth guard true')
  //     return true;
  //   } else {
  //     console.log('auth guard false')
  //     this.router.navigate(['/login']); // Redirect to login page if not authenticated
  //     return false;
  //   }
  // }
}
